<!-- eslint-disable -->
<template>
  <v-dialog
    @keydown.enter="$emit('deleteData', item.id)"
    v-model="status"
    persistent
    max-width="290"
  >
    <v-card>
      <v-card-title class="d-block">
        {{ $t("are you sure you want delete") }}
        <h5 class="d-block" style="color: #2196f3; font-weight: 500">
          <!-- {{ item.name }} ;? -->
        </h5>
      </v-card-title>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('closePopup')">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          :loading="loader"
          color="blue darken-1"
          text
          @click="$emit('deleteData', item.id)"
        >
          {{ $t("agree") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/* eslint-disable*/
export default {
  props: ["item", "status", "loader"],
  computed: {
    name() {
      if (this.item) {
        return this.item.name||this.$i18n.t('image');
      }
    },
  },
};
</script>
